import { Permission } from '@Constants/Permission.g';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { getFrameLabel } from '@Constants/getFrameLabel';
import { useHasPermission } from '@Contexts/appContext';
import { ApiConstructionSite } from '@Model';
import {
    Card,
    EditFrameMode,
    EditFrameShell,
    FrameEditBase,
    Grid,
    GridColumns,
    type IFrameBodyProps,
    type IFrameEditShellProps,
    TextInput,
    useFrameEditBaseNavigation,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';
import { useParams } from 'react-router';

export function FrameEditConstructionSite(props: IFrameEditShellProps<ApiConstructionSite>) {
    const hasPermission = useHasPermission();
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    return (
        <FrameEditBase<ApiConstructionSite>
            key={primaryKey}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
            apiResourcePath={`${STAMMDATEN_API}/construction_sites`}
            renderer={FrameEditConstructionSiteBody}
            canEdit={props.canEdit !== false && hasPermission(Permission.StammdatenConstructionSiteUpdate)}
            canCreate={props.canCreate !== false && hasPermission(Permission.StammdatenConstructionSiteCreate)}
            canDelete={props.canDelete !== false && hasPermission(Permission.StammdatenConstructionSiteDelete)}
            frameProps={{
                events: {
                    ...frameEditBaseNavigationEvents,
                    ...props.events,
                },
            }}
        />
    );
}

function FrameEditConstructionSiteBody(props: IFrameBodyProps<ApiConstructionSite>) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiConstructionSite>({
        ...props,
        canEdit: props.mode !== EditFrameMode.View,
    });

    return (
        <EditFrameShell
            headerProps={{
                label: getFrameLabel('Baustelle', props.mode),
                resourceLabel: 'Baustelle',
                ...props.events,
            }}
            bannerProps={{
                mode: props.mode,
                loading: props.stateQueueDepth > 0,
                ...props.events,
            }}
        >
            <Card name="headdata" border={'withoutBorder'}>
                <Grid>
                    <GridColumns spans={[6, 6]}>
                        <TextInput {...binder.bindToProp<string>('label')} label={i18n('Bezeichnung')} />
                        <TextInput {...binder.bindToProp<string>('shorthand')} label={i18n('Suchcode')} />
                    </GridColumns>
                </Grid>
                <TextInput {...binder.bindToProp<string>('remarks')} label={i18n('Bemerkung')} inputSize={5} />
            </Card>
        </EditFrameShell>
    );
}
